import React from "react";
import "./index.css";

export const Captcha = React.forwardRef(({className}, ref) => (
    <div ref={ref} className={className}></div>
));

export default Captcha;
